import React from 'react';
import classes from './EmbedCard.module.scss';

export default function EmbedCard({ children }) {
  return <div className={classes.cardContainer}>{children}</div>;
}
